import { StateTable } from './statetable.js';

class DivCalendarDetails extends Tango.Component {

    init() {
        this.tables = [];
    }

    widgetDidMount() {
        const root = document.getElementById(this.root);
        const tables = [
            ...(root.matches('table[data-bind]') ? [root] : []),
            ...root.querySelectorAll('table[data-bind]')
        ];

        this.tables = [];
        for (const t of tables) {
            const st = new StateTable(t, this);
            this.tables.push(st);
            st.render();
            this.renderTotal(t, st);
        }
    }

    // Заполняем итоговую ячейку (tfoot [data-total]) значением всего столбца за месяц,
    // взятым напрямую из состояния графика (data[idx].value) — так Total точно совпадает
    // со значением столбика на графике, а не с суммой округлённых строк.
    renderTotal(table, st) {
        const cell = table.querySelector('[data-total]');
        if (!cell) return;

        const ctrl = ajaxUtils.state.ctrl[st.stateOwner];
        if (!ctrl) return;

        // data-bind = "data[idx].details" -> родитель "data[idx]"
        const parentKey = st.stateKey.replace(/\.details$/, '');
        const parent = parentKey.match(/[^.[\]]+/g)
            .reduce((acc, key) => acc?.[key], ctrl.state);

        const total = (parent && typeof parent.value === 'number') ? parent.value : 0;
        cell.textContent = '$' + total.toLocaleString('en-US',
            { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    // Карта рендереров по имени поля
    get columns() {
        const twoSpans = function (v1, v2) {
            const fragment = new DocumentFragment();
            
            const el1 = document.createElement('span');
            el1.textContent = v1;
            fragment.appendChild(el1);

            const el2 = document.createElement('span');
            el2.innerHTML = '&nbsp;';
            fragment.appendChild(el2);

            const el3 = document.createElement('span');
            el3.textContent = v2;
            el3.classList.add('mic');
            fragment.appendChild(el3);

            return fragment;
        };

        return {
            ticker: (value) => {
                const parts = value.split(':');
                return twoSpans(parts[1], parts[0]);
            },
            adjDividend: (_, item) => {
                return twoSpans(item.adjDividend, item.currencyId);
            }
        };
    }
}

Tango.registerComponent(DivCalendarDetails);